export default __webpack_public_path__ + "static/media/tete80.f65dd782.png";